import { ref } from 'vue';

export const RECENT_CASES_KEY = 'recentlyViewedCases';
export const MAX_RECENT_CASES = 10;

export const normalizeRecentCase = (caseData = {}) => {
    if (!caseData.case_number) {
        return null;
    }

    return {
        case_number: caseData.case_number,
        name: caseData.name || '',
        status: caseData.status || '',
        case_type: caseData.case_type || '',
        date_opened: caseData.date_opened || null
    };
};

export const readRecentCases = () => {
    try {
        const stored = localStorage.getItem(RECENT_CASES_KEY);
        if (!stored) {
            return [];
        }

        const parsed = JSON.parse(stored);
        if (!Array.isArray(parsed)) {
            return [];
        }

        return parsed.map(normalizeRecentCase).filter(Boolean);
    } catch {
        return [];
    }
};

export const writeRecentCases = (cases) => {
    try {
        localStorage.setItem(RECENT_CASES_KEY, JSON.stringify(cases));
    } catch {
        // localStorage unavailable or full
    }
};

export const buildRecentCases = (existingCases, caseData) => {
    const entry = normalizeRecentCase(caseData);

    if (!entry) {
        return existingCases;
    }

    const filteredCases = existingCases.filter((currentCase) => currentCase.case_number !== entry.case_number);
    filteredCases.unshift(entry);

    return filteredCases.slice(0, MAX_RECENT_CASES);
};

export function useRecentCases() {
    const recentCases = ref([]);

    const loadRecentCases = () => {
        recentCases.value = readRecentCases();
        return recentCases.value;
    };

    const addRecentCase = (caseData) => {
        recentCases.value = buildRecentCases(recentCases.value, caseData);
        writeRecentCases(recentCases.value);
        return recentCases.value;
    };

    return {
        recentCases,
        loadRecentCases,
        addRecentCase
    };
}
